module.exports = __webpack_public_path__ + "static/media/CMore_Svezia.f7f83069.png";